/* NT trust rail – port of Talia trust rail v12 (seamless rAF loop, 40px/s, pause on hover, rebuild on resize) */
(function () {
  var SPEED = 40, raf = null, states = [];
  function stop() { if (raf) cancelAnimationFrame(raf); raf = null; states = []; }
  function loop(now) {
    if (!states.length) return;
    for (var i = 0; i < states.length; i++) {
      var s = states[i];
      if (!s.paused) {
        if (s.t0 == null) s.t0 = now - (s.x / SPEED) * 1000;
        s.x = ((now - s.t0) / 1000 * SPEED) % s.half;
        s.track.style.left = -s.x + 'px';
      }
    }
    raf = requestAnimationFrame(loop);
  }
  function setup(root) {
    var clip = root.querySelector('.nt-rail__clip'), track = root.querySelector('.nt-rail__track');
    if (!clip || !track || track.children.length < 2) return;
    var a = track.children[0], b = track.children[1];
    if (!root.__ntTpl) root.__ntTpl = Array.prototype.map.call(a.children, function (c) { return c.cloneNode(true); });
    // reset to one copy of the items per set
    var tpl = root.__ntTpl;
    [a, b].forEach(function (set) { set.innerHTML = ''; tpl.forEach(function (c) { var n = c.cloneNode(true); n.removeAttribute('data-shopify-editor-block'); set.appendChild(n); }); });
    var w = Math.max(260, Math.min(1100, (window.innerWidth || 800) - 24));
    root.style.width = w + 'px';
    track.style.left = '0px';
    void track.offsetWidth;
    var g = 0;
    while (a.offsetWidth < w + 8 && g < 4) {
      tpl.forEach(function (c) { a.appendChild(c.cloneNode(true)); b.appendChild(c.cloneNode(true)); });
      g++; void track.offsetWidth;
    }
    var half = track.scrollWidth / 2;
    if (half < 1) return;
    var st = { track: track, half: half, x: 0, t0: null, paused: false };
    states.push(st);
    clip.onmouseenter = function () { st.paused = true; };
    clip.onmouseleave = function () { st.paused = false; st.t0 = null; };
  }
  function init() {
    stop();
    document.querySelectorAll('[data-nt-rail]').forEach(setup);
    if (states.length) raf = requestAnimationFrame(loop);
  }
  var rt, lastW = window.innerWidth;
  function onR() { if (window.innerWidth === lastW) return; lastW = window.innerWidth; clearTimeout(rt); rt = setTimeout(init, 250); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(init, 40); });
  else setTimeout(init, 40);
  window.addEventListener('load', function () { setTimeout(init, 200); });
  window.addEventListener('resize', onR);
  window.addEventListener('orientationchange', function () { lastW = -1; onR(); });
  document.addEventListener('shopify:section:load', init);
})();
